import { useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { OptionTemplate } from "shared/api/middleware-api-client";
import { REACT_APP_GERS_API_URL } from "shared/config";

const fetchConfiguratorOptions = async () => {
  const result = await axios.get(`${REACT_APP_GERS_API_URL}/optiontemplates`, {
    headers: {
      Accept: "application/json",
      filter:
        '{"fields":["id", "name","code", "description", "imageId","price"],"where":{"type":{"neq":"background"}}}',
    },
  });
  return result.data as OptionTemplate[];
};

export const useConfiguratorOptions = () => {
  const queryClient = useQueryClient();

  const getConfiguratorOptions = async () =>
    await queryClient.fetchQuery({
      queryKey: ["configurator-options"],
      queryFn: fetchConfiguratorOptions,
    });

  return { getConfiguratorOptions };
};
